<template>
  <figure ref="figureChartRef">
    <v-chart
      autoresize
      ref="barChartFornecedor"
      :options="chartConfig"
      v-if="chartConfig.show"
      :init-options="initOptions"
      :theme="theme"
    />
  </figure>
</template>

<script>
import chartMixin from '@/mixins/chart-mixin';

export default {
  mixins: [chartMixin],
  props: {
    title: String,
    categories: Array,
    values: Array,
    theme: {
      type: String,
      default: 'primary',
    },
    userCurrencyFormatter: {
      type: Boolean,
      default: false,
    },
    useDecimalNumber: {
      type: Boolean,
      default: false,
    },
    truncateXLabel: {
      type: Number,
      default: 0,
    },
    left: {
      type: [Number, String],
      default: 60,
    },
    loading: Boolean,
  },
  data() {
    return {
      chartData: {
        show: false,
        responsive: true,
        maintainAspectRatio: false,
        title: {
          text: this.title,
        },
        legend: {},
        tooltip: {
          formatter: this.getTootlTipFormatter(),
        },
        xAxis: {
          type: 'category',
          data: this.categories,
          axisLabel: {
            rotate: -45,
            formatter: this.truncateXLabel > 0
              ? this.axisFormatterTruncate(this.truncateXLabel) : null,
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false,
          },
        },
        series: [{
          data: this.values,
          type: 'bar',
        }],
        grid: {
          left: this.left,
          top: 50,
          right: 20,
          bottom: 40,
        },
      },
      initOptions: {
        width: this.$vuetify.breakpoint.mdAndDown ? undefined : 400,
        height: this.$vuetify.breakpoint.mdAndDown ? undefined : 250,
      },
    };
  },
  computed: {
    chartConfig() {
      const config = { ...this.chartData };
      config.title.text = this.title;
      config.xAxis.data = this.categories;
      config.series[0].data = this.values;
      return config;
    },
  },
  methods: {
    getTootlTipFormatter() {
      if (this.userCurrencyFormatter) {
        return this.simpleTooltipCurrencyFormatter;
      }
      if (this.useDecimalNumber) {
        return this.decimalNumberFormatter;
      }
      return null;
    },
    setupInitialChartConfig() {
      if (this.$vuetify.breakpoint.mdAndDown) {
        return;
      }

      this.initOptions.width = this.$refs.figureChartRef.offsetWidth;
    },
  },
  watch: {
    loading() {
      if (!this.$refs.barChartFornecedor) {
        return;
      }
      if (this.loading) {
        this.showChartLoading('barChartFornecedor');
      } else {
        this.hideChartLoading('barChartFornecedor');
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.setupInitialChartConfig();
      this.chartData.show = true;
    });
  },
};
</script>

<style scoped>
  @media (min-width: 1260px) {
    .echarts {
      width: 100% !important;
      height: 100% !important;
    }
  }
</style>
